// extracted by mini-css-extract-plugin
export var card = "_a1-0";
export var failedIcon = "_a1-4";
export var failedIconBadge = "_a1-3";
export var icon = "_a1-1";
export var successIcon = "_a1-2";